/*
 * wish-card-gift.js — «Είναι για δώρο! ☐ Φτιάξε τη δική σου κάρτα» stays on ONE line (snippets/wish-card-gift.liquid).
 *
 * Stelios 09/10/2026: on his phone it still broke onto two lines. A phone set to larger text, or a zoomed page, has
 * less room than any width a test can name, so the row measures itself: while the link sits under the box instead of
 * beside it, the row's type steps down half a pixel at a time (to 11 px), then the gaps close and the box gets a little
 * smaller, then the type goes on down to 9 px (11/10: at 10 it still broke on his phone — a 360 phone zoomed to 130%
 * is 277 px wide, and the panel needs 9 there). Measured on the preview: one line from 277 px up, larger text too;
 * only a page zoomed past that lets the link take the next line, whole.
 * Every row, on the cart page and in the «Προστέθηκε στο καλάθι σου» panel, each time either is drawn again or the
 * screen changes.
 */
(() => {
  if (window.__mbgFit) return;
  window.__mbgFit = true;
  const FLOOR = 11, MIN = 9;   // 11 px before the gaps and the box give way, 9 px at the very least

  // the link is under the box, not beside it
  function wrapped(row) {
    const ask = row.querySelector('.mbg-ask');
    const link = row.querySelector(':scope > .mbg-link');
    if (!ask || !link || !link.offsetParent) return false;
    const a = ask.getBoundingClientRect();
    return link.getBoundingClientRect().top > a.top + a.height / 2;
  }

  function fit(row) {
    if (row.querySelector('.mbg-d[open]')) return;   // open: the link steps aside, the words under it wrap as words do
    const ask = row.querySelector('.mbg-ask');
    row.style.fontSize = '';
    row.style.columnGap = '';
    row.style.removeProperty('--mbg-box');
    if (ask) ask.style.gap = '';
    if (!wrapped(row)) return;
    let size = parseFloat(getComputedStyle(row).fontSize) || 14;
    const down = (to) => {
      while (wrapped(row) && size > to) {
        size = Math.max(to, size - 0.5);
        row.style.fontSize = size + 'px';
      }
    };
    down(FLOOR);
    if (wrapped(row)) {
      row.style.columnGap = '0.6rem';
      if (ask) ask.style.gap = '0.6rem';
      row.style.setProperty('--mbg-box', '1.8rem');
    }
    down(MIN);
  }

  function fitAll() {
    document.querySelectorAll('.mbg-row .mbg:not(.mbg--on)').forEach(fit);
  }

  let timer = 0;
  const soon = () => {
    clearTimeout(timer);
    timer = setTimeout(fitAll, 60);
  };

  function watch() {
    fitAll();
    // the panel and the cart page are drawn again after every add and every change of quantity
    if ('MutationObserver' in window) {
      const mo = new MutationObserver(soon);
      document.querySelectorAll('cart-drawer, #main-cart-items, cart-items').forEach((el) => {
        mo.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      });
    }
    window.addEventListener('resize', soon);
    document.addEventListener('toggle', soon, true);   // the box opened or closed (a <details>)
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(soon);
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', soon);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
